import { 
	CLAIM_ORDER, 
	REMOVE_ACTIVE_ORDER, 
	SET_ACTIVE_ORDER, 
	SET_QB_TOKEN,
	SET_CANT_FULFILL, 
	SET_IMAGE,
	TOGGLE_DELIVERY_PICKEDUP, 
	TOGGLE_FULFILLMENT,
	UPDATE_EMAIL_CAMPAIGNS,
	UPDATE_ORDER, 
	SET_MANUAL_DELIVERY,
	UPDATE_ADMIN_CONTROLS,
	UPDATE_ORDER_PAYMENT_OBJECT,
	UPDATE_PICKUP_DATE, 
	UPDATE_TRACKING_CODE,
	UPDATE_LEAD_TIME 
} from '../actions/types';

import { PENDING, FULFILLED, REJECTED } from 'redux-promise-middleware';

const defaultState = {
	loading:false,
	data:false,
	err:false
}

const handleChangeProduct = ( _product, action ) => {

	if(_product._id === action.product._id){
		
		switch(action.type){
			
			case SET_CANT_FULFILL:
				return {
					// ...
					..._product,
					confirmFulfillment: false,
					orderStatus: {
						packing: false,
						delivering: false,
						delivered: false,
						cantFulfill: true
					},
					pickupDate: undefined,
					manualDelivery: false,
					trackingCode: '',
					signedImage: '',
				}

			case SET_IMAGE: 
				return {
					..._product,
					signedImage: action.image
				}


			case SET_MANUAL_DELIVERY:

				return {
					..._product,
					manualDelivery: true,
					trackingCode: '',
					signedImage: '',
					pickupDate: undefined,
					orderStatus: {
						packing: true,
						delivering: false,
						delivered: false,
						cantFulfill: false
					}
				}

			case TOGGLE_DELIVERY_PICKEDUP :

				return {
					...action.product,
					signedImage: '',
					orderStatus: {
						...action.product.orderStatus,
						delivering : !action.product.orderStatus.delivering,
						delivered : false
					}
				}
			
			case TOGGLE_FULFILLMENT :
				return {
					...action.product,
					confirmFulfillment: !_product.confirmFulfillment
				}

			case UPDATE_PICKUP_DATE:
				return {
					...action.product,
					pickupDate: action.pickupDate
				}

			case UPDATE_LEAD_TIME:
				return {
					...action.product, 
					leadTime: action.leadTime
				}
				
			case UPDATE_TRACKING_CODE:
				return {
					..._product,
					manualDelivery: false,
					trackingCode: action.trackingCode,
					signedImage: '',
					orderStatus: {
						packing: true,
						delivering: false,
						delivered: false,
						cantFulfill: false
					}
				}

			default: 
				return {
					..._product,
				}

		}

	}

	return _product;
}

export const activeOrderReducer = (state = defaultState, action) => {
	switch(action.type){

		case `${CLAIM_ORDER}_${PENDING}`:
			return {
				loading: false,
				data:false,
				err: false
			}
		
		case `${CLAIM_ORDER}_${FULFILLED}`:
			return {
				loading: true,
				data: action.payload.data.order
			}
		
		case `${CLAIM_ORDER}_${REJECTED}`:
			return {
				loading: false,
				data:false,
				err: action.payload.data.err
			}

		case REMOVE_ACTIVE_ORDER:
			return defaultState;

		case SET_ACTIVE_ORDER: {
			const { order } = action;

			return {
				...state,
				data:order
			}
		}

		case "TOGGLE_FULFILLMENT_bak" :

			const { product } = action;

			return {
				...state,
				data: {
					...state.data,
					products: [
						...state.data.products.map(
							p => {

								if(p._id === product._id){
									p.confirmFulfillment = !p.confirmFulfillment;
								}

								return p;
							}
						)
					]
				}
			}

		case UPDATE_ADMIN_CONTROLS: {
			return {
				...state,
				data: {
					...state.data,
					adminControls: action.adminControls
				}
			}
		}

		case UPDATE_EMAIL_CAMPAIGNS: {
			return {
				...state,
				data: {
					...state.data,
					emailCampaigns: action.emailCampaigns
				}
			}
		}

		case UPDATE_ORDER: {
			const { order } = action;
			const stateOrder = state.data;

			return {
				...state,
				data: stateOrder._id === order._id? order: stateOrder
			}
		}

		case UPDATE_ORDER_PAYMENT_OBJECT:
				return {
					...state,
					data: {
						...state.data,
						payment: action.payment
					}
				}
	
		case SET_CANT_FULFILL :
		case SET_MANUAL_DELIVERY :
		case SET_IMAGE: 
		case TOGGLE_DELIVERY_PICKEDUP : 
		case TOGGLE_FULFILLMENT :
		case UPDATE_LEAD_TIME:
		case UPDATE_PICKUP_DATE :
		case UPDATE_TRACKING_CODE : {

			const { 
				product
			} = action;

			const { confirmCheckoutId } = product;

			return {
				...state,
				data: {
					...state.data,

					confirmCheckout: state.data.confirmCheckout.map(
						_checkoutLocation => {
							if( _checkoutLocation._id === confirmCheckoutId ){
								return {
									..._checkoutLocation,
									products: _checkoutLocation.products.map( ( _product ) => handleChangeProduct( _product, action) )
								}
							}

							return _checkoutLocation;
						}
					),

					products: state.data.products.map( ( _product ) => handleChangeProduct( _product, action) )
					
				}
			}
		}

		case `UPDATE_PICKUP_DATE_bak` : {

			const { pickupDate, product } = action; 
			return {
				...state,
				data: {
					...state.data,
					products: [
						...state.data.products.map(
							_product => {

								if(_product.product.supplierId === product.product.supplierId){

									return {
										..._product,
										pickupDate
									}

								}

								return _product;
							}
						)
					]
				}
			}

		}

		default:
			return state;
	}
}

const qbDefaultState = {
	qbToken: "",
	hydrated: false
}

export const qbTokenReducer = (state = qbDefaultState, action)=>{

	switch(action.type){
		case SET_QB_TOKEN:
			// console.log(action)
			return {
				...state,
				qbToken:action.qbToken,
				hydrated: true
			}
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/components/orders-v2/reducers/index.js